/**
 * @author Kumaravel Pazhani
 * @email kumaravel@qdmplatforms.com
 * @create 12/12/202 
 * @modify 12/12/202 
 * @desc Providing the ThemeContext from /src/context which is used in /src/App.js
 */

import React from "react";
import {
    EntityRelationShipContext, EntityGroupRelationShipContext , EntityLeftContext, ZoomContext,
    JsonCheckerContext, PropertiesContext, DrawLineContext, RightSideNav,CollapseForEntity,LoadingManagement,RenameManagement
} from "../";
import { DataJson } from '../../contexts/enterprise'
import { converData } from './getEntities';
import axios from 'axios';
import environment from '../../config';
// let jsondata = {"personas":[{"entity":"User","status":"draft","db_objectname":"merchant_AINQA2","entity_group_name":"personas","attributes":{"description":"testing user table","id":"4e689402-fe51-4e0e-8226-6eaf2ba339db","type":{"label":"Personas","value":"personas"},"left":10,"top":10,"permission":{"secondary_owner":{"label":"person2","value":"person2"},"primary_owner":{"label":"person1","value":"person1"}},"style":{"color":"red"}},"fields":[{"name":"user_id","properties":{"datatype":"Integer"},"fieldType":"f","attributes":{"id":"454b2f86-66ed-4391-8341-966e524aec41","table":"User","tableID":"4e689402-fe51-4e0e-8226-6eaf2ba339db","selected_color":"red"}}]}],"things":[{"entity":"User_profile","status":"draft","db_objectname":"merchant_AINQA2","entity_group_name":"things","attributes":{"description":"testing profile table","id":"feb24542-c89a-4611-b86d-56e7678321e9","type":{"label":"Things","value":"things"},"left":491,"top":168,"permission":{"secondary_owner":{"label":"person4","value":"person4"},"primary_owner":{"label":"person3","value":"person3"}},"style":{"color":"red"}},"fields":[{"name":"profile_id","properties":{"datatype":"Integer"},"fieldType":"f","attributes":{"id":"30e8f6f9-c2e5-4d42-b72a-48fbe4011edb","table":"User_profile","tableID":"feb24542-c89a-4611-b86d-56e7678321e9","selected_color":"red"}},{"name":"user_id","properties":{"datatype":"Integer"},"fieldType":"f","attributes":{"id":"2c7f120c-e4c3-48c5-ae1d-29468087a09d","table":"User_profile","tableID":"feb24542-c89a-4611-b86d-56e7678321e9","selected_color":"red"}}]}]}

// let relationshipcontext = [{"attributes":{"cuurententity":{"entity":"User_profile","status":"draft","db_objectname":"merchant_AINQA2","entity_group_name":"things","attributes":{"description":"testing profile table","id":"feb24542-c89a-4611-b86d-56e7678321e9","type":{"label":"Things","value":"things"},"left":491,"top":168,"permission":{"secondary_owner":{"label":"person4","value":"person4"},"primary_owner":{"label":"person3","value":"person3"}},"style":{"color":"red"}},"fields":[{"name":"profile_id","properties":{"datatype":"Integer"},"fieldType":"f","attributes":{"id":"30e8f6f9-c2e5-4d42-b72a-48fbe4011edb","table":"User_profile","tableID":"feb24542-c89a-4611-b86d-56e7678321e9","selected_color":"red"}},{"name":"user_id","properties":{"datatype":"Integer"},"fieldType":"f","attributes":{"id":"2c7f120c-e4c3-48c5-ae1d-29468087a09d","table":"User_profile","tableID":"feb24542-c89a-4611-b86d-56e7678321e9","selected_color":"red"}}]},"targetTable":{"entity":"User","status":"draft","db_objectname":"merchant_AINQA2","entity_group_name":"personas","attributes":{"description":"testing user table","id":"4e689402-fe51-4e0e-8226-6eaf2ba339db","type":{"label":"Personas","value":"personas"},"left":10,"top":10,"permission":{"secondary_owner":{"label":"person2","value":"person2"},"primary_owner":{"label":"person1","value":"person1"}},"style":{"color":"red"}},"fields":[{"name":"user_id","properties":{"datatype":"Integer"},"fieldType":"f","attributes":{"id":"454b2f86-66ed-4391-8341-966e524aec41","table":"User","tableID":"4e689402-fe51-4e0e-8226-6eaf2ba339db","selected_color":"red"}}]},"targetTableColumn":{"name":"user_id","properties":{"datatype":"Integer"},"fieldType":"f","attributes":{"id":"454b2f86-66ed-4391-8341-966e524aec41","table":"User","tableID":"4e689402-fe51-4e0e-8226-6eaf2ba339db","selected_color":"red"}},"currentField":{"name":"user_id","properties":{"datatype":"Integer"},"fieldType":"f","attributes":{"id":"2c7f120c-e4c3-48c5-ae1d-29468087a09d","table":"User_profile","tableID":"feb24542-c89a-4611-b86d-56e7678321e9","selected_color":"red"}}},"status":"draft","entity":"User_profile","version":"1.0","target_entity":"User","relationship":"User_profile.user_id in User.user_id","db_objectname":"as"}]
let left = { "things": [{ "entity": "qwqwqw", "status": "draft", "db_objectname": "merchant_AINQA2", "entity_group_name": "things", "isAcceptUserInput":true ,"isActivity": true, "activity": { "create": true, "update": true, "read": false, "delete": false }, "attributes": { "description": null, "id": "ef386217-9ce7-4068-b88d-d224d4104a49", "type": { "label": "Things", "value": "things" }, "left": 35, "top": 32, "permission": { "secondary_owner": null, "primary_owner": null }, "style": { "color": "red" } }, "fields": [{ "name": "as", "properties": { "datatype": "Date", "Security": { "Encryption": false, "Sensitive_Information": false, "Personal_information": false, "indexed": true, "masked": true, "unique": false, "autoIncrement": false, "integrityCheck": false } }, "fieldType": "f", "attributes": { "id": "f4cff360-4a59-4b06-b27c-d98baf95d499", "table": "qwqwqw", "tableID": "ef386217-9ce7-4068-b88d-d224d4104a49", "selected_color": "red" } }, { "name": "asas", "properties": { "datatype": "PositiveInt" }, "fieldType": "f", "attributes": { "id": "505638bc-8f53-4260-8336-9ed1a06e304c", "table": "qwqwqw", "tableID": "ef386217-9ce7-4068-b88d-d224d4104a49", "selected_color": "red" } }] }] }
const LeftEntity = (props) => {

    // let datalist = converData(getdata)
    let [ listOfEntityCollaps,setListOfEntityCollaps ] = React.useState({
        listOfCollapse: []
    })

    let [leftEntity, setEntity] = React.useState({
        list: {}
    });
    let [Data, setData] = React.useState({
        Data: {}
    })
    let [relation, setRelation] = React.useState({
        list: []
    });
    let [grouprelation, setgroupRelation] = React.useState({
        list: [],
        delete:[]
    });
    let [grouprelationDelete, setGroupRelationDelete] = React.useState({
        lists: []
    });
    let [drawLine, setCount] = React.useState({
        count: 0,
        clearCount: 0
    });

    let [zoom, setZoom] = React.useState({ zoom: 1 });
    let [loading,setLoading] = React.useState({
        isLoading:false
    });
    let [renameObj,setRenameObj] = React.useState({
        rename:[]
    })
    let [jsonChecker, setJsonChecker] = React.useState({
        isopen: false,
        oldValue: "",
        newJSON: "",
        versionList: [],
        compareVersion: [],
        compareVersionList: [],
        oldCode: "",
        newCode: "",
        viewVersion: ""
    });

    let [properties, setProperties] = React.useState({
        isopen: false,
        editFieldData: {},
        editTable: {},
        relationDataField: {},
        databaseProperties:[]
    });
    let [rightSideNav, setRightSideNav] = React.useState({
        isopen: false,
        isVersion: false
    });
    React.useEffect(() => {
        if (!sessionStorage.metaId) {
            return false
        }
        // let valueE = sessionStorage.projectId ?? 'ad8c5c3e-161f-4635-8b46-4b857fa6071e';
        // axios
        //   .post("http://13.71.3.63:8084/api/read_documents", {
        //     db_name: "QDM_Metadata",
        //     entity: "EnterpriseModuler",
        //     filter: `EnterpriseModuler.EnterpriceModelerid == '${valueE}'`,
        //     return_fields: "EnterpriseModuler"
        //   })
        //   .then((response) => {
        //       console.log(response);
        //     if (
        //       Object.keys(
        //         response.data.result[response.data.result.length - 1].EnterpriseModuler.attributes
        //       ).length > 0
        //     ) {

        //         list.enterPriseList= response.data.result[response.data.result.length - 1].EnterpriseModuler.attributes
        //         setData({
        //           ...list
        //         })

        //     }
        //   })
        //   .catch((err) => { });
        initialize();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const initialize  = async() =>{
         ;
        let value = sessionStorage.metaId;
       await axios
            .post(`${environment.api_url}/api/get_schema`, {
                "filter": {
                    "columname": "metadataId",
                    "operator": "equals",
                    "value": value
                },
                metadata_dbname:environment.database
            }
            ).then(response => {
                let data = converData(response.data);
                setEntity({
                    ...leftEntity,
                    list: data.entity,
                    saveToPulishParams: response?.data?.Result
                });

                let setRelationship = data.relation;
                if (response.data.Result.attributes && response.data.Result.attributes.length > 0) {
                    let Multirelations = response.data.Result.attributes[0].relationship;
                    setRelationship = [...setRelationship, ...Multirelations]
                }
               
                setRelation({
                    ...relation,
                    list: setRelationship
                });
                 
              if(data.grouprelation){
                let setGroupRelationship = data.grouprelation;
                if (response.data.Result.attributes && response.data.Result.attributes.length > 0) {
                    let Multirelations = response.data.Result.attributes[0].relationship;
                    setGroupRelationship = [...setGroupRelationship, ...Multirelations]
                }
                setgroupRelation({
                    ...grouprelation,
                    list: setGroupRelationship
                });
            }
            else{
                setgroupRelation({
                    ...grouprelation,
                });
            }

                setListOfEntityCollaps({
                    listOfCollapse:response?.data?.Result?.attributes?.[0]?.listOfCollapse  ?? []

                });
                let { count } = drawLine
                setCount({
                    ...drawLine,
                    count: count + 1
                })
            })
            .catch(err => {
            });
        await axios.post(`${environment.api_url}/api/read_documents`, {
            "db_name": `${environment.database}`,
            "entity": `${environment.qdm_property_entity}`,
            "return_fields": `{${environment.qdm_property_entity}}`
            
        })
        .then((response)=>{
             ;
            let dataProperty  = response?.data?.result?.map(prop_value=>{
                prop_value.label = prop_value?.QDMProperties?.datatype;
                prop_value.value = prop_value?.QDMProperties?.datatype;

                return prop_value;
            })
            setProperties({
                ...properties,
                databaseProperties:dataProperty ?? []
            })
        })
        .catch(error=>{

        });
        setLoading({
            isLoading:true
        });
    };

    return (
        <EntityLeftContext.Provider value={{ ...leftEntity, setEntity }}>
            <ZoomContext.Provider value={{ ...zoom, setZoom }}>
                <JsonCheckerContext.Provider value={{ ...jsonChecker, setJsonChecker }}>
                    <CollapseForEntity.Provider  value ={{...listOfEntityCollaps,setListOfEntityCollaps}}>
                        <PropertiesContext.Provider value={{ ...properties, setProperties }}>
                            <RightSideNav.Provider value={{ ...rightSideNav, setRightSideNav }}>
                                <EntityRelationShipContext.Provider value={{ ...relation, setRelation }}>
                                <EntityGroupRelationShipContext.Provider value={{ ...grouprelation, setgroupRelation }}>
                                    <DrawLineContext.Provider value={{ ...drawLine, setCount }}>
                                        <LoadingManagement.Provider  value={{...loading,setLoading}}>
                                            <RenameManagement.Provider value={{...renameObj,setRenameObj}}>
                                               {props.children}
                                            </RenameManagement.Provider>
                                        </LoadingManagement.Provider>
                                    </DrawLineContext.Provider>
                                    </EntityGroupRelationShipContext.Provider>
                                </EntityRelationShipContext.Provider>
                            </RightSideNav.Provider>
                        </PropertiesContext.Provider>
                    </CollapseForEntity.Provider>
                </JsonCheckerContext.Provider>
            </ZoomContext.Provider>
        </EntityLeftContext.Provider>
    );
};

export default LeftEntity;



// const getdata=  {
//     "Result": {
//         "client": "CRAYOND",
//         "db_name": "DB_CRAYOND",
//         "metadataId": "6920f35c-f8ce-4040-9f49-d35ec3de1462",
//         "lastupdatetime": 20210121095454,
//         "metadataname": "a5si3k73kjy8",
//         "attributes": [],
//         "active": "Y",
//         "metadata": [
//             {
//                 "entity": "User",
//                 "status": "draft",
//                 "db_objectname": "merchant_AINQA2",
//                 "entity_group_name": "personas",
//                 "attributes": {
//                     "description": "testing user table",
//                     "id": "4e689402-fe51-4e0e-8226-6eaf2ba339db",
//                     "type": {
//                         "label": "Personas",
//                         "value": "personas"
//                     },
//                     "left": 10,
//                     "top": 10,
//                     "permission": {
//                         "secondary_owner": {
//                             "label": "person2",
//                             "value": "person2"
//                         },
//                         "primary_owner": {
//                             "label": "person1",
//                             "value": "person1"
//                         }
//                     },
//                     "style": {
//                         "color": "red"
//                     }
//                 },
//                 "fields": [
//                     {
//                         "name": "user_id",
//                         "properties": {
//                             "datatype": "Integer"
//                         },
//                         "fieldType": "f",
//                         "attributes": {
//                             "id": "454b2f86-66ed-4391-8341-966e524aec41",
//                             "table": "User",
//                             "tableID": "4e689402-fe51-4e0e-8226-6eaf2ba339db",
//                             "selected_color": "red"
//                         }
//                     }
//                 ],
//                 "client": "CRAYOND",
//                 "metadataId": "6920f35c-f8ce-4040-9f49-d35ec3de1462",
//                 "entitycode": "8cb1c1ca-e476-4f67-88a3-14e05de711eb",
//                 "active": "Y",
//                 "lastupdatetime": 20210121095454,
//                 "version": "1.0"
//             },
//             {
//                 "entity": "User_profile",
//                 "status": "draft",
//                 "db_objectname": "merchant_AINQA2",
//                 "entity_group_name": "things",
//                 "attributes": {
//                     "description": "testing profile table",
//                     "id": "feb24542-c89a-4611-b86d-56e7678321e9",
//                     "type": {
//                         "label": "Things",
//                         "value": "things"
//                     },
//                     "left": 491,
//                     "top": 168,
//                     "permission": {
//                         "secondary_owner": {
//                             "label": "person4",
//                             "value": "person4"
//                         },
//                         "primary_owner": {
//                             "label": "person3",
//                             "value": "person3"
//                         }
//                     },
//                     "style": {
//                         "color": "red"
//                     }
//                 },
//                 "fields": [
//                     {
//                         "name": "profile_id",
//                         "properties": {
//                             "datatype": "Integer"
//                         },
//                         "fieldType": "f",
//                         "attributes": {
//                             "id": "30e8f6f9-c2e5-4d42-b72a-48fbe4011edb",
//                             "table": "User_profile",
//                             "tableID": "feb24542-c89a-4611-b86d-56e7678321e9",
//                             "selected_color": "red"
//                         }
//                     },
//                     {
//                         "name": "user_id",
//                         "properties": {
//                             "datatype": "Integer"
//                         },
//                         "fieldType": "f",
//                         "attributes": {
//                             "id": "2c7f120c-e4c3-48c5-ae1d-29468087a09d",
//                             "table": "User_profile",
//                             "tableID": "feb24542-c89a-4611-b86d-56e7678321e9",
//                             "selected_color": "red"
//                         }
//                     }
//                 ],
//                 "client": "CRAYOND",
//                 "metadataId": "6920f35c-f8ce-4040-9f49-d35ec3de1462",
//                 "entitycode": "17c65584-ecd5-441d-aac3-50b62ad804cf",
//                 "active": "Y",
//                 "lastupdatetime": 20210121095454,
//                 "version": "1.0"
//             }
//         ],
//         "entity_relationship": [
//             {
//                 "attributes": {
//                     "cuurententity": {
//                         "entity": "User_profile",
//                         "status": "draft",
//                         "db_objectname": "merchant_AINQA2",
//                         "entity_group_name": "things",
//                         "attributes": {
//                             "description": "testing profile table",
//                             "id": "feb24542-c89a-4611-b86d-56e7678321e9",
//                             "type": {
//                                 "label": "Things",
//                                 "value": "things"
//                             },
//                             "left": 491,
//                             "top": 168,
//                             "permission": {
//                                 "secondary_owner": {
//                                     "label": "person4",
//                                     "value": "person4"
//                                 },
//                                 "primary_owner": {
//                                     "label": "person3",
//                                     "value": "person3"
//                                 }
//                             },
//                             "style": {
//                                 "color": "red"
//                             }
//                         },
//                         "fields": [
//                             {
//                                 "name": "profile_id",
//                                 "properties": {
//                                     "datatype": "Integer"
//                                 },
//                                 "fieldType": "f",
//                                 "attributes": {
//                                     "id": "30e8f6f9-c2e5-4d42-b72a-48fbe4011edb",
//                                     "table": "User_profile",
//                                     "tableID": "feb24542-c89a-4611-b86d-56e7678321e9",
//                                     "selected_color": "red"
//                                 }
//                             },
//                             {
//                                 "name": "user_id",
//                                 "properties": {
//                                     "datatype": "Integer"
//                                 },
//                                 "fieldType": "f",
//                                 "attributes": {
//                                     "id": "2c7f120c-e4c3-48c5-ae1d-29468087a09d",
//                                     "table": "User_profile",
//                                     "tableID": "feb24542-c89a-4611-b86d-56e7678321e9",
//                                     "selected_color": "red"
//                                 }
//                             }
//                         ]
//                     },
//                     "targetTable": {
//                         "entity": "User",
//                         "status": "draft",
//                         "db_objectname": "merchant_AINQA2",
//                         "entity_group_name": "personas",
//                         "attributes": {
//                             "description": "testing user table",
//                             "id": "4e689402-fe51-4e0e-8226-6eaf2ba339db",
//                             "type": {
//                                 "label": "Personas",
//                                 "value": "personas"
//                             },
//                             "left": 10,
//                             "top": 10,
//                             "permission": {
//                                 "secondary_owner": {
//                                     "label": "person2",
//                                     "value": "person2"
//                                 },
//                                 "primary_owner": {
//                                     "label": "person1",
//                                     "value": "person1"
//                                 }
//                             },
//                             "style": {
//                                 "color": "red"
//                             }
//                         },
//                         "fields": [
//                             {
//                                 "name": "user_id",
//                                 "properties": {
//                                     "datatype": "Integer"
//                                 },
//                                 "fieldType": "f",
//                                 "attributes": {
//                                     "id": "454b2f86-66ed-4391-8341-966e524aec41",
//                                     "table": "User",
//                                     "tableID": "4e689402-fe51-4e0e-8226-6eaf2ba339db",
//                                     "selected_color": "red"
//                                 }
//                             }
//                         ]
//                     },
//                     "targetTableColumn": {
//                         "name": "user_id",
//                         "properties": {
//                             "datatype": "Integer"
//                         },
//                         "fieldType": "f",
//                         "attributes": {
//                             "id": "454b2f86-66ed-4391-8341-966e524aec41",
//                             "table": "User",
//                             "tableID": "4e689402-fe51-4e0e-8226-6eaf2ba339db",
//                             "selected_color": "red"
//                         }
//                     },
//                     "currentField": {
//                         "name": "user_id",
//                         "properties": {
//                             "datatype": "Integer"
//                         },
//                         "fieldType": "f",
//                         "attributes": {
//                             "id": "2c7f120c-e4c3-48c5-ae1d-29468087a09d",
//                             "table": "User_profile",
//                             "tableID": "feb24542-c89a-4611-b86d-56e7678321e9",
//                             "selected_color": "red"
//                         }
//                     }
//                 },
//                 "status": "draft",
//                 "entity": "User_profile",
//                 "target_entity": "User",
//                 "relationship": "User_profile.user_id == User.user_id",
//                 "db_objectname": "as",
//                 "client": "CRAYOND",
//                 "active": "Y",
//                 "metadataId": "6920f35c-f8ce-4040-9f49-d35ec3de1462",
//                 "lastupdatetime": 20210121095454,
//                 "relationId": "58254e74-5dee-45a7-885f-dcf58e08e52d"
//             }
//         ]
//     },
//     "Code": 201
// }